import { render, staticRenderFns } from "./AddServiceCategory.vue?vue&type=template&id=ea5e52fa&"
import script from "./AddServiceCategory.vue?vue&type=script&lang=js&"
export * from "./AddServiceCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports